module.exports = "/images/edit.svg";